import styled from "styled-components";
import Image from "next/image";
import { breakpoints } from "styles";
import {
  textStyles,
  toCSS,
  colors,
  spacing,
  radius
} from "design-system/foundation";

export const PracticeCardWrapper = styled.section`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacing["5xl"]} ${spacing["8xl"]};
  gap: ${spacing["5xl"]};

  @media ${breakpoints.mobile} {
    padding: ${spacing["2xl"]} ${spacing["2xl"]} ${spacing["5xl"]};
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const PracticeCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  align-items: center;

  @media ${breakpoints.tablet} {
    width: 320px;
  }
`;

export const ContentImage = styled(Image)`
  width: 256px;
  height: 256px;
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  align-items: center;
  text-align: center;
`;

export const TextTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h4)}
  color: ${colors.text.base.primary};
`;

export const TextDesc = styled.p`
  margin: ${spacing.none};
  color: ${colors.text.base.secondary};
  ${toCSS(textStyles.body.body3Regular)}
`;

export const ContentButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    width: 320px;
  }
`;

export const ContentBadge = styled.div`
  border-radius: ${radius.xs};
  background: ${colors.bg.warning.secondarySoft};
  padding: ${spacing.xs} ${spacing.md};
`;

export const BadgeText = styled.p`
  margin: ${spacing.none};
  text-align: center;
  color: ${colors.text.semantic.warning};
  ${toCSS(textStyles.body.body4Regular)}
`;
